const SemVer = require('../classes/semver')

const inc = (version, release, options, identifier) => {
  if (typeof (options) === 'string') {
    identifier = options
    options = undefined
  }

  try {
    return new SemVer(version, options).inc(release, identifier).version
  } catch (er) {
    return null
  }
}
module.exports = inc



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/inc.js
// module id = 2186
// module chunks = 0